import { arrayMove, insertAtIndex, removeAtIndex } from "./array"

export const moveBetweenContainers = (items, activeContainer, activeIndex, overContainer, overIndex, item) => {
  return {
    ...items,
    [activeContainer]: removeAtIndex(items[activeContainer], activeIndex),
    [overContainer]: insertAtIndex(items[overContainer], overIndex, item),
  }
}

export const handleDragOver = ({ active, over, setItemGroups }) => {
  const overId = over?.id

  if (!overId) {
    return
  }

  // Safety checks for mobile/touch events
  if (!active?.data?.current?.sortable) {
    return
  }

  const activeContainer = active.data.current.sortable.containerId
  const overContainer = over.data.current?.sortable?.containerId || over.id

  if (activeContainer !== overContainer) {
    setItemGroups((prevItemGroups) => {
      const activeIndex = active.data.current.sortable.index
      const activeItemId = active.id

      // Check if over is a sortable item (has sortable data) or a droppable container
      const isSortableItem = over.data.current?.sortable?.containerId !== undefined
      const overIndex = isSortableItem
        ? over.data.current.sortable.index ?? prevItemGroups[overContainer]?.length ?? 0
        : prevItemGroups[overContainer]?.length ?? 0

      // Critical: Check if the item is already in the target container
      // This prevents infinite loops when the item has already been moved
      const itemAlreadyInTarget = prevItemGroups[overContainer]?.includes(activeItemId)
      if (itemAlreadyInTarget) {
        // Item is already in target container, check if it's at the right position
        const currentIndexInTarget = prevItemGroups[overContainer]?.indexOf(activeItemId)
        if (currentIndexInTarget === overIndex) {
          // Already at the correct position, no update needed
          return prevItemGroups
        }
      }

      // Only proceed if item is not in target container OR is at wrong position
      const newItemGroups = moveBetweenContainers(
        prevItemGroups,
        activeContainer,
        activeIndex,
        overContainer,
        overIndex,
        activeItemId
      )

      // Additional safety check: only update if state actually changed
      const hasChanged =
        prevItemGroups[activeContainer]?.length !== newItemGroups[activeContainer]?.length ||
        prevItemGroups[overContainer]?.length !== newItemGroups[overContainer]?.length ||
        prevItemGroups[activeContainer]?.some((item, idx) => item !== newItemGroups[activeContainer]?.[idx]) ||
        prevItemGroups[overContainer]?.some((item, idx) => item !== newItemGroups[overContainer]?.[idx])

      return hasChanged ? newItemGroups : prevItemGroups
    })
  }
}

export const handleDragEnd = ({ active, over, setActiveId, setItemGroups, itemGroups }) => {
  if (!over) {
    setActiveId(null)
    return
  }

  // Safety checks for mobile/touch events
  if (!active?.data?.current?.sortable) {
    setActiveId(null)
    return
  }

  if (active.id !== over.id) {
    const activeContainer = active.data.current.sortable.containerId
    const overContainer = over.data.current?.sortable?.containerId || over.id
    const activeIndex = active.data.current.sortable.index

    // Check if over is a sortable item (has sortable data) or a droppable container
    const isSortableItem = over.data.current?.sortable?.containerId !== undefined
    const overIndex = isSortableItem
      ? over.data.current.sortable.index ?? itemGroups[overContainer]?.length ?? 0
      : itemGroups[overContainer]?.length ?? 0

    setItemGroups((itemGroups) => {
      let newItems
      if (activeContainer === overContainer) {
        newItems = {
          ...itemGroups,
          [overContainer]: arrayMove(itemGroups[overContainer], activeIndex, overIndex),
        }
      } else {
        newItems = moveBetweenContainers(itemGroups, activeContainer, activeIndex, overContainer, overIndex, active.id)
      }
      return newItems
    })
  }
  setActiveId(null)
}
